export default {
    LENDINGCLUB_STANDARD: "lendingclub_standard",
    PROCEED_STANDARD: "proceed_standard",
    SYNCHRONY_STANDARD: "synchrony_standard",
    HFD_STANDARD: "hfd_standard",
    CLARITYPAY_STANDARD: "claritypay_standard",
}
